import { WebRequest } from 'framework-ui-components';

export const sostitutoImposta = id => WebRequest.get('api/V1/SostitutoImposta/OttieniSostitutoImpostaDaId', { id });

export const sostitutoImpostaDaCodiceFiscale = (codiceFiscale, studio) => WebRequest.get('api/V1/SostitutoImposta/SostitutoImpostaDaCodiceFiscale', { codiceFiscale, studio });

export const ottieniSostitutoImposta = (codiceFiscale, codiceUfficio, codiceSede) => WebRequest.get('api/V1/SostitutoImposta/OttieniSostitutoImposta', { codiceFiscale, codiceUfficio, codiceSede });

export const creaSostitutoImposta = cmd => WebRequest.post('api/V1/SostitutoImposta/CreaSostitutoImposta', cmd);

export const modificaSostitutoImposta = cmd => WebRequest.post('api/V1/SostitutoImposta/ModificaSostitutoImposta', cmd);

export const disabilitaSostitutoImposta = id => WebRequest.post('api/V1/SostitutoImposta/DisabilitaSostitutoImposta', {}, { id });

export const abilitaSostitutoImposta = id => WebRequest.post('api/V1/SostitutoImposta/AbilitaSostitutoImposta', {}, { id });

export const gestioneSostitutiImpostaAbilitata = () => WebRequest.get('api/V1/SostitutoImposta/GestioneSostitutiImpostaAbilitata', {});

export const casisticaModificaSostitutiImpostaDaDichiarazioni = (studio, codiceFiscale, codiceSede, anno) => WebRequest.get('api/V1/SostitutoImposta/CasisticaModificaSostitutiImpostaDaDichiarazioni', {
  studio, codiceFiscale, codiceSede, anno,
});

export const codiceFiscaleAppartieneSostitutoCentralizzato = () => WebRequest.get('api/V1/SostitutoImposta/codiceFiscaleAppartieneSostitutoCentralizzato', {});
